import { handleResponse } from "@/_helpers/handle-response";
import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_ITTENTION;

export const resetService = {
  change,
  reset,
  confirm
};

function change(newPassword1, newPassword2) {
  const requestOptions = {
    method: "post",
    url: "/auth/password/change/",
    data: {
      new_password1: newPassword1,
      new_password2: newPassword2
    }
  };
  return axios(requestOptions)
    .then(handleResponse)
    .then(user => {
      return user;
    });
}

function reset(email) {
  const requestOptions = {
    method: "post",
    url: "/auth/password/reset/",
    data: {
      email: email
    }
  };
  return axios(requestOptions).then(handleResponse);
  // remove user from local storage to log user out
}

function confirm(newPassword1, newPassword2, uid, token) {
  const requestOptions = {
    method: "post",
    url: "/auth/password/reset/confirm/",
    data: {
      new_password1: newPassword1,
      new_password2: newPassword2,
      uid: uid,
      token: token
    }
  };
  return axios(requestOptions).then(handleResponse);
  // remove user from local storage to log user out
}

function testing() {
  
}
